import { configureStore } from "@reduxjs/toolkit";
import parameterReducer from "lib/slices/parameterSlice";
import soucheReducer from "lib/slices/soucheSlice";
import especeReducer from "lib/slices/especeSlice";
import guideReducer from "lib/slices/guideSlice";
import medicamentReducer from "lib/slices/medicamentSlice";
import diseaseReducer from "lib/slices/diseaseSlice";
import userReducer from "lib/slices/userSlice";
import unitReducer from "lib/slices/unitSlice";
import followReducer from "lib/slices/followSlice";

export const store = configureStore({
  reducer: {
    parameter: parameterReducer,
    souche: soucheReducer,
    espece: especeReducer,
    guide: guideReducer,
    medicament: medicamentReducer,
    disease: diseaseReducer,
    user: userReducer,
    unit: unitReducer,
    follow: followReducer,
  },
});
